/**
 * Created by Andrey Popov on 5/27/25.
 */

const LinesRewards = {
    energy: [2, 6, 15, 40, 100],
    rubies: [2, 6, 14, 30],
    orderStar: [2, 6, 14, 30, 62]
};

if (typeof cc === "undefined") {
    module.exports = LinesRewards;
}
